// pp-calc-costo-empaque.js — ¿Cuánto Cuesta Empacar un Pedido?
// (/pages/cuanto-cuesta-empacar-un-pedido)
//
// Suma simple pero honesta del costo de empaque POR PEDIDO:
//
//   costo por pedido = caja + relleno + (precio del rollo ÷ cajas que sella)
//                      + etiqueta + otros
//   mensual = costo por pedido × pedidos al mes · anual = mensual × 12
//
// La cinta es el único concepto que se prorratea: nadie sabe cuánta cinta
// gasta "por pedido", pero todos saben cuánto cuesta el rollo y más o menos
// cuántas cajas sella (40–80 según el patrón de sellado).
//
// Etiqueta y otros son opcionales (vacío = 0). Si el precio del rollo es 0 o
// va vacío, la cinta cuesta 0 y no exigimos las cajas por rollo.
// Aritmética pura probada en tests/calc-costo-empaque.test.mjs.
(function (root) {
  'use strict';

  var MESES_POR_ANO = 12;

  // Entradas: pedidosMes (>0), costoCaja (≥0), costoRelleno (≥0),
  // precioRollo (≥0) + cajasPorRollo (>0 cuando hay rollo),
  // costoEtiqueta y costoOtros opcionales (vacío = 0). Todo en $ MXN.
  function calcularCosto(e) {
    if (!e) return null;
    var pedidos = num(e.pedidosMes);
    var caja = num(e.costoCaja);
    var relleno = num(e.costoRelleno);
    var rollo = num(e.precioRollo);
    var cajasRollo = num(e.cajasPorRollo);
    var etiqueta = opcional(e.costoEtiqueta);
    var otros = opcional(e.costoOtros);

    if (pedidos === null || pedidos <= 0) return null;
    if (caja === null || caja < 0) return null;
    if (relleno === null || relleno < 0) return null;
    if (etiqueta === null || etiqueta < 0) return null;
    if (otros === null || otros < 0) return null;

    var cinta = 0;
    if (rollo !== null && rollo > 0) {
      if (cajasRollo === null || cajasRollo <= 0) return null;
      cinta = rollo / cajasRollo;
    } else if (rollo === null && cajasRollo !== null) {
      // Capturó cajas pero no el precio del rollo: falta un dato de la cinta.
      return null;
    }

    var porPedido = caja + relleno + cinta + etiqueta + otros;
    if (porPedido <= 0) return null;

    var mensual = porPedido * pedidos;
    var desglose = [
      { concepto: 'caja', costo: caja },
      { concepto: 'relleno', costo: relleno },
      { concepto: 'cinta', costo: cinta },
      { concepto: 'etiqueta', costo: etiqueta },
      { concepto: 'otros', costo: otros }
    ];
    desglose.forEach(function (d) { d.pct = (d.costo / porPedido) * 100; });

    return {
      costoPorPedido: porPedido,
      costoMensual: mensual,
      costoAnual: mensual * MESES_POR_ANO,
      cintaPorPedido: cinta,
      desglose: desglose
    };
  }

  // Campo opcional: vacío cuenta como 0; basura ("abc") sigue siendo null.
  function opcional(x) {
    if (x === null || x === undefined || String(x).trim() === '') return 0;
    return num(x);
  }

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  root.PPCalcCostoEmpaque = {
    calcularCosto: calcularCosto
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-costo-empaque]');
    if (!raiz) return;
    var C = window.PPCalcCostoEmpaque;
    var $ = function (sel) { return raiz.querySelector(sel); };
    var form = $('form');
    var out = $('[data-calc-resultado]');

    function telemetria(inputs, resultado) {
      try {
        var KEY = 'sb_publishable_48y6S7h2eQ-9uTF7pCNJNQ_Q0mz8VVX';
        fetch('https://dhygbnysealeblqorjts.supabase.co/functions/v1/calc-telemetria', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', 'apikey': KEY, 'Authorization': 'Bearer ' + KEY },
          body: JSON.stringify({ calculadora: 'costo_empaque', inputs: inputs, resultado: resultado })
        }).catch(function () {});
      } catch (_) { /* la telemetría jamás rompe la calculadora */ }
    }

    function fmt(n, dec) {
      return n.toLocaleString('es-MX', { maximumFractionDigits: dec === undefined ? 0 : dec });
    }

    var ETIQUETAS = {
      caja: 'Caja',
      relleno: 'Relleno de protección',
      cinta: 'Cinta (prorrateada por rollo)',
      etiqueta: 'Etiqueta de envío',
      otros: 'Otros insumos'
    };

    function correr(conTelemetria) {
      var f = new FormData(form);
      var datos = {
        pedidosMes: f.get('pedidos_mes'), costoCaja: f.get('costo_caja'),
        costoRelleno: f.get('costo_relleno'), precioRollo: f.get('precio_rollo'),
        cajasPorRollo: f.get('cajas_rollo'), costoEtiqueta: f.get('costo_etiqueta'),
        costoOtros: f.get('costo_otros')
      };
      var r = C.calcularCosto(datos);
      pintar(r);
      if (conTelemetria && r) {
        telemetria(
          { pedidos_mes: Number(datos.pedidosMes) || null, costo_caja: Number(datos.costoCaja) || null, costo_relleno: Number(datos.costoRelleno) || null, costo_cinta_pedido: Math.round(r.cintaPorPedido * 100) / 100, costo_etiqueta: Number(datos.costoEtiqueta) || null, costo_otros: Number(datos.costoOtros) || null },
          { costo_por_pedido: Math.round(r.costoPorPedido * 100) / 100, costo_mensual: Math.round(r.costoMensual * 10) / 10 }
        );
      }
    }

    function pintar(r) {
      if (!out) return;
      out.hidden = false;
      if (!r) {
        out.innerHTML = '<p class="pp-calc__error">Revisa los datos: pedidos al mes y al menos un costo deben ser mayores a cero (y si capturas rollo de cinta, dinos cuántas cajas sella).</p>';
        return;
      }
      var html = '<div class="pp-calc__veredicto pp-calc__veredicto--ok">';
      html += '<p class="pp-calc__veredicto-titulo">Empacar un pedido te cuesta $' + fmt(r.costoPorPedido, 2) + ' MXN</p>';
      html += '<p class="pp-calc__veredicto-dato">Al mes son <strong>$' + fmt(r.costoMensual) + '</strong> y al año <strong>$' + fmt(r.costoAnual) + '</strong> en puro empaque.</p>';
      html += '</div>';
      html += '<dl class="pp-calc__detalle">';
      r.desglose.forEach(function (d) {
        html += '<div class="pp-calc__detalle-fila"><dt>' + ETIQUETAS[d.concepto] + '</dt><dd>$' + fmt(d.costo, 2) + ' (' + fmt(d.pct, 1) + '%)</dd></div>';
      });
      html += '</dl>';
      html += '<p class="pp-calc__nota">El empaque suele ser de los costos más olvidados del e-commerce; conocerlo por pedido es el paso 1 para bajarlo. Los conceptos más pesados del desglose son el mejor lugar para empezar.</p>';
      // Gancho con precio REAL del catálogo: si su caja le cuesta más que
      // nuestro "desde" (metafield recalculado a diario), se lo decimos.
      var cajasDesde = Number(raiz.dataset.cajasDesde) || 0;
      var cajasUrl = raiz.dataset.cajasUrl || '';
      var filaCaja = null;
      for (var fc = 0; fc < r.desglose.length; fc++) {
        if (r.desglose[fc].concepto === 'caja') filaCaja = r.desglose[fc];
      }
      var pedidosDelMes = r.costoPorPedido > 0 ? Math.round(r.costoMensual / r.costoPorPedido) : 0;
      if (cajasDesde > 0 && cajasUrl && filaCaja && filaCaja.costo > cajasDesde && pedidosDelMes > 0) {
        html += '<p class="pp-calc__nota">Tu caja te está costando <strong>$' + fmt(filaCaja.costo, 2) + '</strong> por pedido — en nuestro catálogo hay <a href="' + cajasUrl + '">cajas desde $' + fmt(cajasDesde) + ' la pieza</a>. Solo con la caja podrías bajar tu costo mensual ≈ <strong>$' + fmt((filaCaja.costo - cajasDesde) * pedidosDelMes) + '</strong>.</p>';
      }
      out.innerHTML = html;
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      correr(true);
      if (out) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    var timerRecalc = null;
    function recalcEnVivo() {
      if (!out || out.hidden) return;
      clearTimeout(timerRecalc);
      timerRecalc = setTimeout(function () { correr(false); }, 350);
    }
    form.addEventListener('input', recalcEnVivo);
    form.addEventListener('change', recalcEnVivo);
  });
})();
